import {
  AcceptanceJPG,
  DarknessJPG,
  KaleidoscopeJPG,
  Love846JPG,
  PantoneVesnaJPG,
  ReflectionOfLovePNG,
  ShapeOfFeelingJPG,
  SunsetFlowersJPG,
} from '@assets/my-works';
import { IWorkItem } from '@models/works';

export const my_works_list: Array<IWorkItem> = [
  {
    id: 'pantone-vesna',
    img: [PantoneVesnaJPG],
    author: 'Настя-Соня Яро',
    name: 'Pantone #VESNA',
    year: '2024',
    price: 45000,
    info: 'акрил, холст, пеноплекс',
    size: '55x75см',
    media: [
      {
        label: 'inst',
        value: '@yaro.nastyasonya',
        link: 'https://www.instagram.com/yaro.nastyasonya',
      },
    ],
  },
  {
    id: 'kaleidoscope',
    img: [KaleidoscopeJPG],
    author: 'Настя-Соня Яро',
    name: 'Калейдоскоп',
    year: '2023',
    price: 10000,
    info: 'акрил, холст',
    size: '50x70см',
    media: [
      {
        label: 'inst',
        value: '@yaro.nastyasonya',
        link: 'https://www.instagram.com/yaro.nastyasonya',
      },
    ],
  },
  {
    id: 'love846',
    img: [Love846JPG],
    author: 'Настя-Соня Яро',
    name: 'Люблю 846',
    year: '2021',
    price: 15000,
    info: 'темпера, холст',
    size: '30x40см',
    media: [
      {
        label: 'inst',
        value: '@yaro.nastyasonya',
        link: 'https://www.instagram.com/yaro.nastyasonya',
      },
    ],
  },
  {
    id: 'sunset-flowers',
    img: [SunsetFlowersJPG],
    author: 'Настя-Соня Яро',
    name: 'Цветы заката',
    year: '2024',
    price: 22000,
    info: 'акрил, холст',
    size: '60х80см',
    media: [
      {
        label: 'inst',
        value: '@yaro.nastyasonya',
        link: 'https://www.instagram.com/yaro.nastyasonya',
      },
    ],
  },
  {
    id: 'reflection-of-love',
    img: [ReflectionOfLovePNG],
    author: 'Настя-Соня Яро',
    name: 'Reflection of love',
    year: '2024',
    price: 20000,
    info: 'штукатурка, текстурная паста, акрил, зеркало',
    size: '50x65см',
    media: [
      {
        label: 'inst',
        value: '@yaro.nastyasonya',
        link: 'https://www.instagram.com/yaro.nastyasonya',
      },
    ],
  },
  {
    id: 'shape-of-feeling',
    img: [ShapeOfFeelingJPG],
    author: 'Настя-Соня Яро / Евгений Дорохов',
    name: 'Форма чувства',
    year: '2024',
    price: 15000,
    info: '3D печать, акрил, холст',
    size: '70×110см',
    media: [
      {
        label: 'inst',
        value: '@yaro.nastyasonya',
        link: 'https://www.instagram.com/yaro.nastyasonya',
      },
      {
        label: 'inst',
        value: '@evgdega',
        link: 'https://www.instagram.com/evgdega',
      },
    ],
  },
  {
    id: 'acceptance',
    img: [AcceptanceJPG],
    author: 'Настя-Соня Яро',
    name: 'Принятие',
    year: '2023',
    price: 12000,
    info: 'акрил, холст',
    size: '50x60см',
    media: [
      {
        label: 'inst',
        value: '@yaro.nastyasonya',
        link: 'https://www.instagram.com/yaro.nastyasonya',
      },
    ],
  },
  {
    id: 'darkness',
    img: [DarknessJPG],
    author: 'Настя-Соня Яро',
    name: 'Мрак',
    year: '2023',
    price: 10000,
    info: 'акрил, холст',
    size: '50x70см',
    media: [
      {
        label: 'inst',
        value: '@yaro.nastyasonya',
        link: 'https://www.instagram.com/yaro.nastyasonya',
      },
    ],
  },
];
